module.exports = __webpack_public_path__ + "static/images/logo-light.8c9d9c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Themes/JWE/logo-light.png
// module id = Gt4f
// module chunks = 12